import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const PrivateRouteBirthdays = ({
  component: Component,
  auth: { birthdaysisAuthenticated, birthdaysloading },
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      birthdaysisAuthenticated ? <Component {...props} /> : <Redirect to="/birthdays/billing" />
    }
  />
);

PrivateRouteBirthdays.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(PrivateRouteBirthdays);

